/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

// Utils
import { useCookies } from 'react-cookie';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../store/AppContext';

// Services
import useUserService from '../../services/userService';
import useEstablishmentService from '../../services/establishmentService';
import adminTypes from '../../constants/adminTypes';

const withAuth = (Component) => {
  function Auth(props) {
    const navigate = useNavigate();

    const [{ adminType }] = useAppContext();
    const { getMe } = useUserService();
    const { getOwnEstablishment } = useEstablishmentService();

    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);

    const [{ user }, stateDispatch] = useAppContext();
    const [cookies] = useCookies(['jwt']);

    const { mutate: getMeMutate } = useMutation('getMe', () => getMe(), {
      onSuccess: (data) => {
        if (data?.data) {
          stateDispatch({ type: 'SET_USER', payload: data.data });
        }
      },
    });

    const { mutate: getOwnEstablishmentMutate } = useMutation('getOwnEstablishment', () => getOwnEstablishment(), {
      onSuccess: (data) => {
        if (data?.data) {
          stateDispatch({ type: 'SET_OWN_ESTABLISHMENT', payload: data.data });
        }
      },
    });

    useEffect(() => {
      if (mounted) {
        if (cookies?.jwt && adminType) {
          getMeMutate();
          if (adminType === adminTypes.establishment) getOwnEstablishmentMutate();
        } else {
          navigate('/logout');
        }
      }
    }, [mounted]);

    if (user) return <Component {...props} />;
    return null;
  }

  if (Component.getInitialProps) {
    Auth.getInitialProps = Component.getInitialProps;
  }

  return Auth;
};

export default withAuth;
